import { SettingsSection, SettingsRow } from '../../Common'
import { NlsLocaleSelect } from '../../../nls/NlsLocaleSelect'
import { ProfileIdentityCard } from '../../Profile/ProfileDetailsPanel'
import { useNls } from '../../../nls/nlsProvider'

type ProfilePanelProps = {
  variant?: 'member' | 'helper'
}

export const ProfilePanel = ({ variant = 'member' }: ProfilePanelProps) => {
  const { t } = useNls()
  return (
    <div className="skSectionStack">
      <SettingsSection title={t('NLSSettingsSectionIdentity')}>
        <div className="skProfileIdentity">
          <ProfileIdentityCard variant={variant} />
        </div>
      </SettingsSection>
      <SettingsSection title={t('NLSSettingsSectionLanguage')}>
        <SettingsRow
          label={t('NLSSettingsLabelDisplayLanguage')}
          hint={t('NLSSettingsHintLanguage')}
          control={<NlsLocaleSelect className="settingsLanguageSelect" />}
        />
      </SettingsSection>
    </div>
  )
}
